import KpiPage from './KpiPage';

const RetentionPage = (props) => {
    const year = 2022; // Example year
    const pageId = 16; // Example page ID


    return (
        <KpiPage year={year} pageId={pageId} pageIdentifier={props.pageIdentifier} />
    );
};

export default RetentionPage;